<script setup lang="ts">
import { computed } from 'vue';
import { type SubProgramItem } from '../types/general';

const props = defineProps<{
  card: SubProgramItem;
}>();

const tagColor = computed(() => {
  const color = props.card.project_type[0].color;
  switch (color) {
    case 'violet':
      return 'text-dark-' + color + ' bg-light-' + color;
    default:
      return 'text-' + color + ' bg-light-' + color;
  }
});
</script>

<template>
  <div class="search-card">
    <span
      class="color-tag"
      :class="tagColor"
      >{{ props.card.project_type[0].label }}</span
    >
    <h4>
      <a :href="props.card.link">{{ props.card.title }}</a>
    </h4>
    <div class="search-card__date">
      <div class="search-card__date__label">{{ props.card.duration.label }}</div>
      <div class="search-card__date__seasons">
        <div
          v-for="item in props.card.season"
          :key="item.id"
        >
          {{ item.label }}
        </div>
      </div>
    </div>

    <p class="search-card__description text-s">{{ props.card.description }}</p>
    <div class="search-card__cta">
      <a
        :href="props.card.link"
        class="btn btn-sm"
      >
        Details
      </a>
    </div>
  </div>
</template>
